import React, { useEffect } from "react";


import Meta from "../components/Meta";
import router from "next/router";

import styles from "../styles/Layout.module.scss"

import { CircularProgress } from "@mui/material";
interface Props {
  preview?: boolean
  children: React.ReactNode
}

const Layout = ({ preview, children }: Props) => {

  const [loading, setLoading] = React.useState(null);

  useEffect(() => {

    const handleStart = (url) => {
      setLoading(true)
    }
    const handleStop = () => {
      setLoading(false)
    }

    router.events.on('routeChangeStart', handleStart)
    router.events.on('routeChangeComplete', handleStop)
    router.events.on('routeChangeError', handleStop)

    return () => {
      router.events.off('routeChangeStart', handleStart)
      router.events.off('routeChangeComplete', handleStop)
      router.events.off('routeChangeError', handleStop)
    }
  }, [router])

  return (
    <>
      {loading ? <div className={styles.loading}><CircularProgress className={styles.colorLoading} /></div> : ''}
      <Meta />
      <div className="min-h-screen">
        <main>{children}</main>
      </div>

    </>
  );
};
export default Layout;
